import { useState, useEffect } from 'react'
import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import { setCrmManagements } from 'redux/features/crmManagements/crmManagementsSlice'
import {  roleIds } from 'utils/Constants'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import moment from 'moment'
import { getPermission } from 'utils/Auth'
import { setUsers } from 'redux/features/users/usersSlice'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Link, useNavigate } from 'react-router-dom'
import Spinner from 'components/loader/Spinner'
import Tooltip from 'components/tooltip/Tooltip'
import { Dropdown } from 'primereact/dropdown'

const SERVICE_PROVIDER_OPTIONS = [
	{ label: 'Nuevo', value: 0 },
	{ label: 'Odito', value: 1 }
]

const initialFormState = () => ({
	newCrmCompanyName: '',
	crmCompanySectorId: null,
	newCrmCompanySectorName: '',
	accountManagerUserIds: [],
	serviceProvider: 0,
	webSiteUrl: ''
})

const CreateCrmModal = ({ visible, onHide, sectors, accountManagerOptions, onSubmit, showToast }) => {
	const [form, setForm] = useState(initialFormState)

	useEffect(() => {
		if (visible) setForm(initialFormState())
	}, [visible])

	const handleChange = (name, value) => setForm((prev) => ({ ...prev, [name]: value }))

	const handleSubmit = () => {
		if (!form.newCrmCompanyName) {
			showToast('Kurumsal Adı Girin', 'error')
			return
		}
		if (!form.crmCompanySectorId && !form.newCrmCompanySectorName) {
			showToast('Sektör Seçin', 'error')
			return
		}
		if (!form.accountManagerUserIds?.length) {
			showToast('Account Manager Seçin', 'error')
			return
		}
		const postData = {
			id: 0,
			crmCompanyId: 0,
			newCrmCompanyName: form.newCrmCompanyName,
			crmCompanySectorId: form.crmCompanySectorId || 0,
			newCrmCompanySectorName: form.newCrmCompanySectorName || '',
			serviceProvider: form.serviceProvider ?? 0,
			webSiteUrl: form.webSiteUrl || '',
			status: 1,
			accountManagerUserIds: form.accountManagerUserIds
		}
		onSubmit(postData)
	}

	return (
		<Dialog
			style={{ width: '50%', height: '' }}
			header='Yeni Müşteri Ekle'
			draggable={false}
			visible={visible}
			onHide={onHide}
		>
			<div className='w-100'>
				<div className='w-100 d-flex flex-column gap-3'>
					<div className='row'>
						<div className='col-md-12'>
							<div className='form-control'>
								<label className='form-control-label'>Kurumsal Adı *</label>
								<input
									className='default-input'
									type='text'
									placeholder='Kurumsal Adı'
									maxLength={200}
									value={form.newCrmCompanyName}
									onChange={(e) => handleChange('newCrmCompanyName', e.target.value)}
								/>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12'>
							<div className='form-control'>
								<label className='form-control-label'>Sektör *</label>
								<Dropdown
									value={form.crmCompanySectorId ?? form.newCrmCompanySectorName}
									onChange={(e) => {
										if (!e.originalEvent) return
										const isId = Number.isInteger(e.value) && sectors.find((s) => s.value === e.value)
										setForm((prev) => ({
											...prev,
											crmCompanySectorId: isId ? e.value : null,
											newCrmCompanySectorName: isId ? '' : e.value
										}))
									}}
									onInput={(e) => setForm((prev) => ({ ...prev, crmCompanySectorId: null, newCrmCompanySectorName: e.target.value }))}
									options={sectors}
									optionLabel='label'
									optionValue='value'
									placeholder='Sektör'
									filter
									filterLocale='tr'
									editable
									filterInputAutoFocus={false}
									className='w-100'
								/>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12'>
							<div className='form-control'>
								<label className='form-control-label'>Account Manager *</label>
								<DefaultSelect
									isClearable
									isSearchable
									isMulti
									handleChange={(e) => handleChange('accountManagerUserIds', e ? e.map((am) => am.value) : [])}
									placeholder='Account Manager'
									selectOptions={accountManagerOptions}
									value={form.accountManagerUserIds?.length ? accountManagerOptions.filter((am) => form.accountManagerUserIds.includes(am.value)) : []}
								/>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-control'>
								<label className='form-control-label'>Hizmet Sağlayıcı</label>
								<Dropdown
									value={form.serviceProvider ?? 0}
									onChange={(e) => handleChange('serviceProvider', e.value)}
									options={SERVICE_PROVIDER_OPTIONS}
									optionLabel='label'
									optionValue='value'
									placeholder='Hizmet Sağlayıcı'
									className='w-100'
								/>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-control'>
								<label className='form-control-label'>Web Site URL</label>
								<input
									className='default-input'
									type='url'
									placeholder='Web Site URL'
									maxLength={200}
									value={form.webSiteUrl}
									onChange={(e) => handleChange('webSiteUrl', e.target.value)}
								/>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12 d-flex justify-content-end gap-3'>
							<Button className='btn-danger' title='Vazgeç' handleClick={onHide} />
							<Button className='btn-success' title='Kaydet' handleClick={handleSubmit} />
						</div>
					</div>
				</div>
			</div>
		</Dialog>
	)
}

const CrmPage = () => {
	const [filterOptions, setFilterOptions] = useState({ searchString: '', status: null, am: [], serviceProvider: null })
	const [createModalOpen, setCreateModalOpen] = useState(false)
	const [accountManagers, setAccountManagers] = useState([])
	const { crmManagements } = useSelector((state) => state)
	const { crmManagementsData } = crmManagements
	const [getCrmManagements, getCrmManagementsLoading] = useRequest()
	const [addCrmManagement] = useRequest()
	const { showToast } = useToast()
	const dispatch = useDispatch()
	const [getUsers] = useRequest()
	const navigate = useNavigate()
	const hasCrmPermission = getPermission('CrmManagement.read')
	const [sectors, setSectors] = useState([])

	useEffect(() => {
		if (!hasCrmPermission) {
			navigate('/')
		}
	}, [hasCrmPermission])

	if (!hasCrmPermission) {
		return null
	}

	useEffect(() => {
		if (!createModalOpen) {
			getCrmManagements('/CrmManagement/GetAllCrmManagements', { method: 'GET'}).then(
				(res) => {
					if (res.data.ok) {
						dispatch(
							setCrmManagements(
								res.data.result.map((c) => ({
									...c,
									crmRoles: c.crmRoles ? c.crmRoles.filter(
										(r) =>
											!r.endDate ||
											(r.endDate &&
												moment(new Date(), 'YYYY-MM-DD').diff(moment(r.endDate).format('YYYY-MM-DD'), 'days') < 1)
									) : [],
								}))
							)
						)
					}
				}
			)
		}
        // Get sectors from API
        getUsers('/CrmManagement/GetCrmCompanySectors', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setSectors(res.data.result.map((s) => ({ label: s.name, value: s.id })))
            }
        })
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setUsers(res.data.result))
			}
		})
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
			params: {
				isDeleteFilter: true
			}
		}).then((res) => {
			if (res.data.ok) {
				setAccountManagers(res.data.result.filter(r => r.roles.map(r => r.id).includes(roleIds.accountManager) ))
			}
		})
	}, [createModalOpen, filterOptions.isArchive])

	useEffect(() => {
		// CRM doesn't need developers, this can be removed or replaced with CRM-specific data
	}, [])

	const handleCreateSubmit = (postData) => {
		addCrmManagement('/CrmManagement/UpsertCrmManagement', {
			method: 'POST',
			data: postData,
		}).then((res) => {
			if (res.data?.ok) {
				showToast('CRM Kaydı Oluşturuldu', 'success')
				setCreateModalOpen(false)
			}
		})
	}

	const handleChnage = (e, name, array) => {
		if (name == 'isArchive') {
			setFilterOptions((prev) => ({ ...prev, [name]: e.value }))
		} else if (e == null || e.length == 0 || e.value == '') {
			setFilterOptions((prev) => ({ ...prev, [name]: null }))
		} else {
			if (array) {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e && e != undefined ? e : e.length > 0 && e,
				}))
			} else {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e.value && e.value != undefined ? e.value : e.length > 0 && e[0].value,
				}))
			}
		}

	}
	
	const filteredCrmManagements = [...crmManagementsData]
	?.sort((a, b) => {
		const nameA = (a.crmCompanyName || '').toLowerCase();
		const nameB = (b.crmCompanyName || '').toLowerCase();
		return nameA.localeCompare(nameB, 'tr');
	})
	?.filter((d) => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach((k) => {
				if (filterOptions[k] != null && filterOptions[k] !== '' && !(Array.isArray(filterOptions[k]) && filterOptions[k].length === 0)) {
					if (k == 'searchString') {
						let uniName = (d.crmCompanyName || '').toLocaleLowerCase('tr')
						rt.push(uniName.includes(filterOptions[k].toLocaleLowerCase('tr')))
					} else if (k == 'sector') {
						rt.push(filterOptions[k].map((e) => e.value).includes(d.crmCompanySectorId))
					} else if (k == 'status') {
						rt.push(d.status === filterOptions[k])
					} else if (k == 'serviceProvider') {
						rt.push(d.serviceProvider === filterOptions[k])
					} else if (k == 'am') {
						const selectedAmIds = filterOptions[k].map((e) => e.value)
						const hasMatchingAm = d.crmAccountManagers?.some(am => selectedAmIds.includes(am.accountManagerUserId))
						rt.push(hasMatchingAm)
					} else {
						rt.push(d.id == filterOptions[k])
					}
				}
			})
		}
		return rt.every((r) => r)
	})
	const accountManagerOptions = accountManagers.map((am) => ({ label: `${am.firstName} ${am.lastName}`, value: am.id }))
	// CRM doesn't need special coloring like projects
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			{getCrmManagementsLoading ? (
				<div className='d-flex w-100 justify-content-center'>
					<Spinner size={3} />
				</div>
			) : (
				<div className='row'>
					<DataTable
						stripedRows
						className='col-md-12 p-1'
						emptyMessage='Hiç Kayıt Bulunamadı'
						size='small'
						responsiveLayout='stack'
						dataKey='id'
						paginator
						alwaysShowPaginator={false}
						paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
						currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
						rows={25}
						header={() => (
							<div className='d-flex justify-content-between gap-3'>
								<div className='row flex-1'>
									<div className='col-md-2 pl-0'>
										<span className='p-input-icon-left '>
											<i className='pi pi-search' />
											{filterOptions.searchString && <i className="pi pi-times" style={{cursor: 'pointer', right: '10px'}} onClick={() => setFilterOptions({ ...filterOptions, searchString: '' })} />}
											<input
												type='text'
												placeholder='Kurumsal Adı'
												className='default-input pl-5 pr-4'
												value={filterOptions.searchString}
												name='searchString'
												onChange={(e) => handleChnage(e.target, 'searchString')}
											/>
										</span>

									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												setFilterOptions(prev => ({ ...prev, am: e || [] }))
											}
											value={filterOptions.am}
											placeholder='Account Manager'
											isSearchable
											isMulti
											isClearable
											selectOptions={accountManagers.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((s) => ({ ...s, name: 'sector' })),
													'sector',
													true
												)
											}
											placeholder='Sektör'
											isSearchable
											isMulti
											selectOptions={sectors}
										/>
									</div>
									<div className='col-md-2'>
										<DefaultSelect
											placeholder='Durum'
											value={filterOptions.status !== null ?
												[{ label: filterOptions.status === 1 ? 'Aktif' : 'Pasif', value: filterOptions.status }] : null}
											selectOptions={[
												{ label: 'Aktif', value: 1 },
												{ label: 'Pasif', value: 0 },
											]}
											handleChange={(e) => setFilterOptions(prev => ({ ...prev, status: e ? e.value : null }))}
											isClearable
										/>
									</div>
									<div className='col-md-2'>
										<DefaultSelect
											placeholder='Hizmet Sağlayıcı'
											value={filterOptions.serviceProvider !== null && filterOptions.serviceProvider !== undefined
												? SERVICE_PROVIDER_OPTIONS.find(o => o.value === filterOptions.serviceProvider) : null}
											selectOptions={SERVICE_PROVIDER_OPTIONS}
											handleChange={(e) => setFilterOptions(prev => ({ ...prev, serviceProvider: e ? e.value : null }))}
											isClearable
										/>
									</div>
								</div>
								<div className='filters-right'>
									{getPermission('CrmManagement.create') && (
										<Button handleClick={() => setCreateModalOpen(true)} className='btn-success' title='Yeni Müşteri Ekle' icon={<Icons.plus />} />
									)}
								</div>
							</div>
						)}
						rowClassName={`cursor-pointer table-hover `}
						rowExpansionTemplate={() => <div>Expansion</div>}
						onRowClick={(e) => {
							navigate(`${e.data.id}`)
						}}
						value={filteredCrmManagements}
					>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: '25%', position: 'relative', padding: '8px' }}
							field='crmCompanyName'
							header='Kurumsal Adı'
							sortable='true'
							body={(rowData) => {
								return (
									<div className='text-sm'>
										<Tooltip textClass='bottom' text={rowData.crmCompanyName} >
											<div className='text-elipsis'>{rowData.crmCompanyName}</div>
										</Tooltip>
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-sm'
							style={{ width: '12%', position: 'relative', padding: '8px' }}
							field='serviceProvider'
							header='Hizmet Sağlayıcı'
							body={(rowData) => {
								const label = SERVICE_PROVIDER_OPTIONS.find(o => o.value === rowData.serviceProvider)?.label
								return <div className='text-sm'>{label ?? 'Belirtilmemiş'}</div>
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: '20%', position: 'relative', padding: '8px' }}
							field='sector'
							header='Sektör'
							body={(rowData) => {
								const sectorLabel = sectors.find(s => s.value === rowData.crmCompanySectorId)?.label || rowData.crmCompanySectorName || 'Belirtilmemiş'
								return (
									<div className='text-sm text-primary'>
										{sectorLabel}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='status'
							header='Durum'
							style={{ width: '10%' }}
							body={(rowData) => {
								const statusLabel = rowData.status === 1 ? 'Aktif' : 'Pasif'
								const statusClass = rowData.status === 1 ? 'text-success' : 'text-danger'
								return (
									<div className={`text-sm ${statusClass}`}>
										<strong>{statusLabel}</strong>
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-sm'
							field='crmAccountManagers'
							header='AM'
							style={{ width: '25%' }}
							body={(rowData) => {
								return (
									<div className='text-sm'>
										{rowData.crmAccountManagers ? rowData.crmAccountManagers?.map((r) => `${r.accountManagerName}`).join(', ') : 'Belirtilmemiş'}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-sm relative-cell'
							style={{ width: '15%', minWidth: '220px', position: 'relative', padding: '8px' }}
							field='createdAt'
							header='Oluşturulma Tarihi'
							body={(rowData) => {
								return (
									<div className='text-sm'>
										<Link target='_blank' className='new-page-link-icon' to={`${rowData.id}`}>
											<span>Yeni Pencerede Aç</span>{' '}
											<span onClick={(e) => e.stopPropagation()}>
												<Icons.arrowRight onClick={(e) => e.stopPropagation()} />
											</span>
										</Link>
										{moment(rowData.createdAt).format('DD/MM/YYYY')}
									</div>
								)
							}}
						/>
					</DataTable>
				</div>
			)}
			<CreateCrmModal
				visible={createModalOpen}
				onHide={() => setCreateModalOpen(false)}
				sectors={sectors}
				accountManagerOptions={accountManagerOptions}
				onSubmit={handleCreateSubmit}
				showToast={showToast}
			/>
		</AnimatedSpan>
	)
}
export default CrmPage
